export function parseBot(code) {
  return eval("const obj = " + code + "\nobj");
}

export function buildGameApi(state, playerIndex) {
  let action = { type: "fold" };
  let message = null;

  const player = state.players[playerIndex];
  const to_beat = state.maxBet - player.current_bet;

  const game = {
    fold: () => { action = { type: "fold" }; },
    check: () => { action = { type: "check" }; },
    bet: (v) => { action = { type: "bet", value: v }; },
    call: () => { action = { type: "call" }; },
    raise: (v) => { action = { type: "raise", value: v }; },
    all_in: () => { action = { type: "all_in" }; },
    say: (m) => { message = String(m).slice(0, 200); },

    current_bet: player.current_bet,
    funds: player.funds,
    pot: state.pot,
    to_beat,
    hand: player.cards,
    community: state.community,
    players: state.players.map((p, i) => ({
      position: i,
      funds: p.funds,
      current_bet: p.current_bet,
      is_folded: p.is_folded,
      is_all_in: p.is_all_in,
    })),
    player_count: state.players.length,
    position: playerIndex,
    first_player: (state.dealerIndex + 1) % state.players.length,
    round: state.round,
    step: state.step,
  };

  return { game, getAction: () => action, getMessage: () => message };
}

export function resolveAction(action, player, state) {
  const to_beat = state.maxBet - player.current_bet;

  if (action.type === "fold") return { type: "fold" };
  if (action.type === "all_in") return { type: "all_in" };

  if (action.type === "check") {
    return to_beat > 0 ? { type: "fold" } : { type: "check" };
  }

  if (action.type === "call") {
    return resolveAction({ type: "bet", value: to_beat }, player, state);
  }

  if (action.type === "raise") {
    return resolveAction({ type: "bet", value: to_beat + (action.value || 0) }, player, state);
  }

  if (action.type === "bet") {
    const amount = action.value ?? 0;
    if (amount <= 0) return resolveAction({ type: "check" }, player, state);
    if (amount > player.funds) return { type: "all_in" };
    return { type: "bet", value: amount };
  }

  return { type: "fold" };
}

export function executeTurn(botCode, state, playerIndex, memory) {
  try {
    const bot = parseBot(botCode);
    const { game, getAction, getMessage } = buildGameApi(state, playerIndex);
    const result = bot.turn({ game, memory });
    const newMemory = result ?? memory;
    const action = resolveAction(getAction(), state.players[playerIndex], state);
    console.log(`[${state.players[playerIndex].config.name}] memory:`, memory, "→", newMemory);
    return { action, message: getMessage(), newMemory };
  } catch {
    return { action: { type: "fold" }, message: null, newMemory: memory };
  }
}
